import { createBrowserClient } from '@supabase/ssr';

const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL!;
const supabaseAnonKey = process.env.NEXT_PUBLIC_ANON_KEY! || process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!;

// Use createBrowserClient so the session is stored in cookies (not localStorage).
// This is required for Google OAuth on web: the server-side auth/callback route
// exchanges the PKCE code and sets a cookie; the browser client must read from
// the same cookie store to pick up the session after the redirect.
export const supabase = createBrowserClient(supabaseUrl, process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!);

export type UserRole = 'customer' | 'seller' | 'delivery_agent' | 'admin' | 'super_admin';

export interface UserProfile {
  id: string;
  email: string;
  full_name: string;
  phone: string | null;
  avatar_url: string | null;
  role: UserRole;
  is_active: boolean;
  seller_mode: 'hyperlocal' | 'national' | 'both';
  seller_latitude: number | null;
  seller_longitude: number | null;
  onboarding_status: 'not_started' | 'in_progress' | 'submitted' | 'approved' | 'rejected';
  kyc_status: 'not_submitted' | 'submitted' | 'under_review' | 'approved' | 'rejected';
  kyc_verified_at: string | null;
  kyc_rejection_note: string | null;
  loyalty_points: number;
  lifetime_points: number;
  created_at: string;
  updated_at: string;
}

export interface SellerOnboarding {
  id: string;
  seller_id: string;
  business_name: string;
  business_type: 'individual' | 'proprietorship' | 'partnership' | 'pvt_ltd' | 'llp';
  business_category: string;
  gst_number: string | null;
  pan_number: string;
  business_address: string;
  city: string;
  state: string;
  pincode: string;
  bank_account_number: string;
  bank_ifsc: string;
  bank_name: string;
  store_name: string;
  store_description: string;
  store_logo_url: string | null;
  approval_status: 'pending' | 'under_review' | 'approved' | 'rejected' | 'on_hold';
  seller_type: 'national' | 'hyperlocal' | 'both';
  delivery_radius_km: number;
  eco_score: number;
  operating_hours: Record<string, unknown> | null;
  notification_prefs: Record<string, unknown> | null;
  ai_check_status: 'pending' | 'checking' | 'passed' | 'failed' | 'needs_review';
  reviewed_by: string | null;
  reviewed_at: string | null;
  rejection_reason: string | null;
  submitted_at: string | null;
  created_at: string;
  updated_at: string;
}
